import { render, staticRenderFns } from "./userCertificationView.vue?vue&type=template&id=432422d0&"
import script from "./userCertificationView.vue?vue&type=script&lang=js&"
export * from "./userCertificationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports